import {Checkbox, ListItemText, MenuItem, TextField} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {Grid, Paper} from "@mui/material/";
import {
    POI_TYPE_TEMPLATE_ASSISTANCE,
    POI_TYPE_TEMPLATE_DMS, POI_TYPE_TEMPLATE_DRIVALIAPARKINGLOTS,
    POI_TYPE_TEMPLATE_EPLUS, POI_TYPE_TEMPLATE_SHARINGPARKINGLOTS
} from "../../../component/Constants";
import {useStatusValuesPoi} from "../../../component/useStatusValuesPoi";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import {CloseRounded} from "@mui/icons-material";
import {usePoiActions} from "../../../service/usePoiActions";
import {PoiTemplate} from "../PoiInterfaces";
import CustomAutocompleteFreeSolo from "../../../component/CustomAutocompleteFreeSolo";

const PoiType = (props: any) => {
    const {row, index, setValue, update, remove, errors, clearErrors, getValues, watch} = props;
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'poi'});
    const {getStatusLabelPoi} = useStatusValuesPoi();
    const {getTemplates, getBrands, getAssistanceTypes, getChargingStations} = usePoiActions();
    const [types, setTypes] = useState<PoiTemplate[]>([]);
    const [brands, setBrands] = useState<any[]>([]);
    const [chargingStationTypes, setChargingStationTypes] = useState<any[]>([]);
    const [assistanceTypeDetails, setAssistanceTypeDetails] = useState<any[]>([]);

    useEffect(() => {
        getTemplates().then((res: any) => {
            setTypes(res.result);
        });
        getBrands().then((res:any)=>{
            setBrands(res.result.map((b:any)=>b.value));
        });
        getChargingStations().then((res:any)=>{
            setChargingStationTypes(res.result.map((it: any)=>it.value));
        });
        getAssistanceTypes().then((res:any)=>{
            setAssistanceTypeDetails(res.result)
        })

    }, []);


    return (
        <Paper elevation={3} sx={{width: "100%", padding: "16px", position: "relative", marginBottom: "10px"}}>
            <IconButton
                aria-label="remove"
                onClick={() => {
                    remove(index);
                }}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                }}
            >
                <CloseRounded/>
            </IconButton>
            {types.length > 0 && <Grid container item rowSpacing={3} columnSpacing={3} xs={12}>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        label={t('type')}
                        select
                        required
                        value={watch(`poiTemplateDetailDTOList.${index}.template`)}
                        onChange={event => {
                            clearErrors(`poiTemplateDetailDTOList.${index}.template`)
                            if (event.target.value) {
                                let foundType = types.find(t => t.template === event.target.value);
                                //update(index, {...row, type: event.target.value, template: (foundType?.template || "")});
                                setValue(`poiTemplateDetailDTOList.${index}.type`, event.target.value);
                                setValue(`poiTemplateDetailDTOList.${index}.template`, (foundType?.template || ""));
                                if(event.target.value === POI_TYPE_TEMPLATE_ASSISTANCE){
                                    setValue(`poiTemplateDetailDTOList.${index}.assistanceTypeDetail`, []);
                                }
                            } else {
                                //update(index, {...row, type: event.target.value, template: ""});
                                setValue(`poiTemplateDetailDTOList.${index}.type`, event.target.value);
                                setValue(`poiTemplateDetailDTOList.${index}.template`, "");
                            }
                        }}
                        error={!!errors.poiTemplateDetailDTOList?.[index]?.type}
                        helperText={errors.poiTemplateDetailDTOList?.[index]?.type?.message}
                    >
                        <MenuItem key={""} value={""}/>
                        {types?.map((type: PoiTemplate) => (
                            <MenuItem key={type.id} value={type.type}>
                                {getStatusLabelPoi(type.type)}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={9}/>
                {watch(`poiTemplateDetailDTOList.${index}.template`) === POI_TYPE_TEMPLATE_EPLUS &&
                <>
                    <Grid item xs={12}>
                        <CustomAutocompleteFreeSolo watch={watch} setValue={setValue} multiple={true}
                                                    field={`poiTemplateDetailDTOList.${index}.chargingStationType`}
                                                    options={chargingStationTypes}
                                                    label={t('typeSection.chargingStationTypeConnectors')}
                                                    placeholder={t('dynamicListPlaceholder')}/>
                    </Grid>
                </>
                }
                {watch(`poiTemplateDetailDTOList.${index}.template`) === POI_TYPE_TEMPLATE_DMS &&
                <>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.phoneNumber')}
                            value={watch(`poiTemplateDetailDTOList.${index}.phoneNumber`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.phoneNumber`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.phoneNumber}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.phoneNumber?.message}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.responsibleName')}
                            value={watch(`poiTemplateDetailDTOList.${index}.responsibleName`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.responsibleName`, event.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.responsiblePhoneNumber')}
                            value={watch(`poiTemplateDetailDTOList.${index}.responsiblePhoneNumber`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.responsiblePhoneNumber`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.responsiblePhoneNumber}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.responsiblePhoneNumber?.message}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.email')}
                            value={watch(`poiTemplateDetailDTOList.${index}.email`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.email`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.email}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.email?.message}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.openingHours')}
                            value={watch(`poiTemplateDetailDTOList.${index}.openingHours`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.openingHours`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.openingHours}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.openingHours?.message}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.idDms')}
                            value={watch(`poiTemplateDetailDTOList.${index}.dmsId`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.dmsId`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.dmsId}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.dmsId?.message}
                        />
                    </Grid>
                </>
                }
                {watch(`poiTemplateDetailDTOList.${index}.template`) === POI_TYPE_TEMPLATE_ASSISTANCE &&
                <>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.assistanceTypeDetails')}
                            select
                            value={watch(`poiTemplateDetailDTOList.${index}.assistanceTypeDetail`)}
                            SelectProps={{
                                multiple: true,
                                renderValue: (selected: any) => {
                                    let result = assistanceTypeDetails.length > 0 ? selected.map((l: any) => getStatusLabelPoi(assistanceTypeDetails.find((ll: any) => ll.id === l)?.value.toUpperCase() || '')).join(', ') : "";
                                    return result.length > 100 ? result.substring(0, 100) + "..." : result;
                                }
                            }}
                           onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.assistanceTypeDetail`, event.target.value);
                            }}
                        >
                            {assistanceTypeDetails?.map((l: any) => (
                                <MenuItem key={l.id} value={l.id}>
                                    <Checkbox color={"accent"}
                                              checked={watch(`poiTemplateDetailDTOList.${index}.assistanceTypeDetail`).indexOf(l.id) > -1}/>
                                    <ListItemText primary={getStatusLabelPoi(l.value)}/>
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.openingHours')}
                            value={watch(`poiTemplateDetailDTOList.${index}.openingHours`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.openingHours`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.openingHours}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.openingHours?.message}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.bodyWorkName')}
                            value={watch(`poiTemplateDetailDTOList.${index}.bodyWorkName`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.bodyWorkName`, event.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.phoneNumber')}
                            value={watch(`poiTemplateDetailDTOList.${index}.phoneNumber`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.phoneNumber`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.phoneNumber}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.phoneNumber?.message}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('typeSection.email')}
                            value={watch(`poiTemplateDetailDTOList.${index}.email`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.email`, event.target.value);
                            }}
                            error={!!errors.poiTemplateDetailDTOList?.[index]?.email}
                            helperText={errors.poiTemplateDetailDTOList?.[index]?.email?.message}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <CustomAutocompleteFreeSolo watch={watch} setValue={setValue} multiple={true}
                                                    field={`poiTemplateDetailDTOList.${index}.brand`}
                                                    options={brands}
                                                    label={t('typeSection.assistanceBrands')}
                                                    placeholder={t('dynamicListPlaceholder')}/>
                    </Grid>
                    <Grid item xs={3}>
                    <TextField
                            fullWidth
                            label={t('typeSection.mechanicalWorkshop')}
                            value={watch(`poiTemplateDetailDTOList.${index}.mechanicalWorkshop`)}
                            onChange={event => {
                                setValue(`poiTemplateDetailDTOList.${index}.mechanicalWorkshop`, event.target.value);
                            }}
                        />
                    </Grid>
                </>
                }
                {(watch(`poiTemplateDetailDTOList.${index}.template`) === POI_TYPE_TEMPLATE_SHARINGPARKINGLOTS || watch(`poiTemplateDetailDTOList.${index}.template`) === POI_TYPE_TEMPLATE_DRIVALIAPARKINGLOTS) &&
                    <>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.openingHours')}
                                value={watch(`poiTemplateDetailDTOList.${index}.openingHours`)}
                                onChange={event => {
                                    setValue(`poiTemplateDetailDTOList.${index}.openingHours`, event.target.value);
                                }}
                                error={!!errors.poiTemplateDetailDTOList?.[index]?.openingHours}
                                helperText={errors.poiTemplateDetailDTOList?.[index]?.openingHours?.message}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('typeSection.parkingLots')}
                                value={watch(`poiTemplateDetailDTOList.${index}.parkingLots`)}
                                onChange={event => {
                                    setValue(`poiTemplateDetailDTOList.${index}.parkingLots`, event.target.value);
                                }}
                                error={!!errors.poiTemplateDetailDTOList?.[index]?.parkingLots}
                                helperText={errors.poiTemplateDetailDTOList?.[index]?.parkingLots?.message}
                            />
                        </Grid>
                    </>
                }
            </Grid>}
        </Paper>
    )
}

export default PoiType;